import React from 'react'
// import PropTypes from 'prop-types'
// import styled from '@emotion/styled'
// import InlineSVG from 'svg-inline-react'
import Icon from 'components/shared/Icon'
import Tooltip from 'components/shared/Tooltip'
import TooltipText from './TooltipText'

import iconEvent from 'assets/icons/ico-event.svg'

import Popover from '../../shared/Popover'
import TriggerEventPicker from './TriggerEventPicker'

const TriggerEvent = () => {
  return (
    <Popover
      trigger={popoverProps => (
        <Tooltip
          trigger={tooltipProps => {
            return (
              <Icon 
                {...popoverProps} 
                {...tooltipProps}  
                src={iconEvent}
              />
            )
          }}
          type='arrow'
          position='top'
        >
          <TooltipText>Trigger event</TooltipText>
        </Tooltip>
      )}
      type='arrow'
      position='top'
    >
      <TriggerEventPicker />
    </Popover>

  )
}

export default TriggerEvent
